<template>
<div class="login-backgroud">
	<div class="vertical-center">
	<div class="container">
		<div class="row">
      <div class="col-md-3 col-sm-3"></div>
			<div class="col-md-6 col-sm-6">
				<div class="login-card card card-default">
					<div class="card-header text-center">
						<img class="img img-fluid" src="/static/images/logo.png" ></img>
					</div>
					<div class="card-body">
						<form name='loginForm' v-on:submit.prevent="login()" data-toggle="validator" role="form">
              <div v-show="error" style="color:red; word-wrap:break-word;"></div>
							<div class="form-group has-feedback inner-addon left-addon">
								<label>Usuário</label>
								<input class="form-control" placeholder="Usuário" autofocus="" type='text' name='username' v-on:click="mensagem = ''" required v-model="data.body.username" />
								<i class="fa fa-user"></i>
							</div> 

							<div class="form-group inner-addon left-addon">
								<label>Senha</label>
								<input class="form-control" placeholder="Senha" type="password" value="" name='password' v-on:click="mensagem = ''" required v-model="data.body.password"/>
								<i class="fa fa-lock"></i>
							</div>
							<div class="form-group">
                <template v-if="mensagem !== ''">
                  <span class="text-danger">{{mensagem}}</span>
                </template>
								<br>
                <label><input v-model="data.rememberMe" type="checkbox" /> Lembrar </label>
							</div>
							<div class="form-group">
								
									<input type="hidden" name="${_csrf.parameterName}" value="${_csrf.token}" />
                  <button type="submit" class="btn btn-primary btn-block">
                    <i v-if="isLoading" class="fa fa-spinner fa-spin"></i> Login
                  </button>
								
							</div>
						</form>
            <div class="text-right">
						  <span class="copyright"><small>Spark Software. Todos os direitos reservados</small></span>
            </div>


					</div>
				</div>
			</div>
      <div class="col-md-3 col-sm-3"></div>
		</div>
		</div>
	</div>
</div>
	<!-- /.row -->

</template>
<script>
export default {
  data () {
    return {
      context: 'login context',
      isLoading: false,
      mensagem: '',
      loaded: false,
      data: {
        body: {
          username: '',
          password: ''
        },
        rememberMe: true,
        fetchUser: true
      },
      error: null
    }
  },
  ready () {
    var _this = this
    // Set up $auth.ready with other arbitrary loaders (ex: language file).
    setTimeout(function () {
      _this.loaded = true
    }, 500)
    // Test manual refresh on boot (instead of via plugin).
    // if (this.$auth.token()) {
    //   this.$auth.refresh()
    // }
  },
  mounted () {
    console.log(this.$auth.redirect())
    // Can set query parameter here for auth redirect or just do it silently in login redirect.
  },
  methods: {
    login () {
      this.isLoading = true
      var redirect = this.$auth.redirect()
      this.$auth.login({
        body: this.data.body, // Vue-resource
        data: this.data.body, // Axios
        rememberMe: this.data.rememberMe,
        redirect: {name: redirect ? redirect.from.name : 'account'},
        fetchUser: this.data.fetchUser
        // window.localStorage.setItem('id_token', data.id_token)
      })
      .then(() => {
        const token = this.$auth.token()
        this.$store.commit('SET_AUTH_TOKEN', token)
        this.isLoading = false
      }, (res) => {
        console.log('error ' + this.context)
        this.error = res.data
        console.log(this.error)
        this.mensagem = 'Usuário ou Senha incorretos. Verifique e tente novamente.'
        this.isLoading = false
      })
    },
    logout () {
      this.$auth.logout({
        makeRequest: true,
        // window.localStorage.removeItem('id_token'),
        success () {
          console.log('success ' + this.context)
        },
        error () {
          console.log('error ' + this.context)
        }
      })
    },
    unimpersonate () {
      this.$auth.unimpersonate({
        success () {
          console.log('success ' + this.context)
        },
        error () {
          console.log('error ' + this.context)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/Login.vue